var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPin01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    d: "M11,35.5c-1,0-1.8-0.8-1.8-1.8V21.3C4.5,16.5,4.6,8.7,9.4,4S22-0.7,26.8,4.2c2.2,2.3,3.5,5.4,3.5,8.6 c0,3.2-1.3,6.3-3.5,8.6v12.4c0,1-0.8,1.8-1.8,1.7c-0.3,0-0.5-0.1-0.8-0.2L18,32.2l-6.2,3.1C11.5,35.5,11.3,35.5,11,35.5z M12.7,23.8 v7.1l4.5-2.2c0.5-0.2,1.1-0.2,1.6,0l4.5,2.2v-7.1C19.9,25.4,16.1,25.4,12.7,23.8L12.7,23.8z M18,4c-4.8,0-8.8,3.9-8.8,8.8 s3.9,8.8,8.8,8.8s8.8-3.9,8.8-8.8C26.7,7.9,22.8,4,18,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPin01);
export default __webpack_public_path__ + "static/media/ico-pin-01.d916feeb77aa10bcc74bd080b706e2a5.svg";
export { ForwardRef as ReactComponent };